/** Fixed bottom CTA with safe-area padding — use on every sticky bottom button row. */
export default function BottomButtonContainer({ children, className = "" }) {
  return (
    <div
      className={`kipa-bottom-actions ${className}`}
      style={{
        paddingBottom: "calc(var(--safe-area-bottom, 0px) + 24px)",
      }}
    >
      {children}
    </div>
  );
}
